export default __webpack_public_path__ + "static/media/Image1.a71797c4.jpg";